import axios, { CancelToken } from 'axios'
import { getCookieClient } from 'settings/app/helpers'
import { CANCELING_PREVIOUS_REQUEST_ROUTES } from './axiosRequests'
import { DEV_API_URL, API_TIMEOUT, __dev__ } from 'settings/app/constants'

// live system api patch with or without port
export const apiPath = localStorage.getItem('apiPath') || DEV_API_URL

// base instance
const navigatorAPI = axios.create({
  baseURL: apiPath,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Version: '1',
  },
})

// pre request interceptor with cancel handling
let cancel
navigatorAPI.interceptors.request.use(
  (request) => {
    const { clientId } = getCookieClient()

    // append client id for localized result data
    if (clientId !== null) {
      request.params = { ...request.params, clientId }
    }

    // cancel previous running request when route is in cancel list
    const { 0: reqRoute } = request.url.split('/')

    if (CANCELING_PREVIOUS_REQUEST_ROUTES.includes(reqRoute)) {
      if (cancel) {
        // console.log('test')
        cancel('>> cancel previous request <<')
      }
    }

    // append cancel token
    request.cancelToken = new CancelToken((c) => {
      cancel = c
    })

    return request
  },
  (error) => Promise.reject(error)
)

// response interceptor to show error messages
navigatorAPI.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export default navigatorAPI
